import { FormControl } from "@mui/material"
import { styled } from "@mui/system"

const CustomFormControl = styled((FormControl))(({ theme }) => ({
    marginBottom: '10px',
    width: '100%'
}))

export default CustomFormControl